import HowItWorksTimelineItem from "./HowItWorksTimelineItem";

export default HowItWorksTimelineItem;
